export enum EntryStatus {
	Default = 'default',
	Ready = 'ready',
	Pending = 'pending'
}